import type { CSSProperties } from "react";

/** Hover and focus treatment shared by the directory's cards. */
export const cardHover =
  "transition-colors hover:bg-muted/50 focus-within:ring-2 focus-within:ring-ring/40";

/** Entrance stagger index — see --stagger in styles/globals.css. */
export const stagger = (i: number) => ({ "--stagger": i }) as CSSProperties;
